// extracted by mini-css-extract-plugin
export default {"wrapper":"ar-z","response":"br-z","error":"cr-z","disabled":"dr-z","buttons":"er-z","feedbackQuestionSection":"fr-z","yesNoWrapper":"gr-z"};